import React, { useEffect, useState } from "react";
import "./App.css";
import Layout from "./layouts/ob-layout-components/sidebar/Layout";
import AppRoute from "./routes/AppRoute";
import { BrowserRouter, useLocation } from "react-router-dom";
import { ConstantAPISContext } from "./context/ConstantAPISContext";
import YilListeAPI from "./apis/OB/Get/YilListeAPI";
import MahalleListeAPI from "./apis/OB/Get/MahalleListeAPI";
import MenuListeAPI from "./apis/OB/Get/MenuListeAPI";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CssBaseline } from "@mui/material";
import { ThemeProviderComponent } from "../src/context/themeProviderContext";
import BolgeKoduAPI from "./apis/OB/Get/BolgeKoduAPI";
import SessionStorageService from "./services/StorageService";
import * as Yup from "yup";
import ComboBox from "./pages/OB/EAbonelik/deneme";
import DuyurularAPI from "./apis/DuyurularAPI";

const App = () => {
  const [yearListeDatas, setYearListeDatas] = useState<any[]>([]);
  const [mahalleListeDatas, setMahalleListeDatas] = useState<any[]>([]);
  const [bolgeListeDatas, setBolgeListeDatas] = useState<any[]>([]);
  const [menuList, setMenuList] = useState<any[]>([]);
  const [menuListAll, setMenuListALL] = useState<any[]>([]);
  const [menuListAltMenu, setMenuListAltMenu] = useState<any[]>([]);
  const [kullaniciVarmi, setKullaniciVarmi] = useState<boolean>(!!SessionStorageService.getUserInfo());
  const [duyurularListe, setDuyurularListe] = useState<any[]>([]);
  let user = SessionStorageService.getUserInfo();
  // useEffect(() => {
  //   const handleKeyDown = (event:any) => {
  //     if (event.key === 'Enter') {
  //       const form = event.target.form;
  //       const index = Array.prototype.indexOf.call(form, event.target);
  //       form.elements[index + 1]?.focus();
  //       event.preventDefault();
  //     }
  //   };

  //   document.addEventListener('keydown', handleKeyDown);

  //   return () => {
  //     document.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, []); 
  function organizeMenu(items: any[]) {
    const menuMap: any = {};

    // Öncelikle üst başlıkları (parentId === 0 olanları) sıralı şekilde ekleyelim
    const ustBasliklar = items
      .filter(item => item.parentId === 0)
      .sort((a, b) => a.menuSirasi - b.menuSirasi);

    ustBasliklar.forEach(item => {
      menuMap[item.sqId] = {
        ustBaslik: item,
        altBasliklar: []
      };
    });

    // Alt başlıkları uygun üst başlık sırasına göre ekleyelim
    const altBasliklar = items
      .filter(item => item.parentId !== 0)
      .sort((a, b) => a.menuSirasi - b.menuSirasi); // Alt başlıkları kendi içinde sıralıyoruz

    altBasliklar.forEach(item => {
      if (menuMap[item.parentId]) {
        menuMap[item.parentId].altBasliklar.push(item);
      }
    });

    // Üst başlıkların sırasına göre sıralanmış bir dizi döndürelim
    return ustBasliklar.map(item => menuMap[item.sqId]);
  }



  useEffect(() => {
    const fetchMenu = async () => {
      MenuListeAPI.getMenuListe(undefined, undefined)
        .then((res) => {
          setMenuListALL(
            res.data.filter((x: any) => x.panel === 1 && x.aktifPasif === 'A')
          );

          const organizedMenu = user
            ? (() => {
              switch (user.rol) {
                case 'ADMIN':
                  return organizeMenu(
                    res.data.filter(
                      (x: any) => x.panel === 1 && x.aktifPasif === 'A'
                    )
                  );
                case 'UYE':
                  return organizeMenu(
                    res.data.filter(
                      (x: any) =>
                        x.panel === 1 &&
                        x.aktifPasif === 'A' &&
                        x.uyeTipi === 2
                    )
                  );
                case 'PERSONEL':
                  return organizeMenu(
                    res.data.filter(
                      (x: any) =>
                        x.panel === 1 &&
                        x.aktifPasif === 'A' &&
                        (x.uyeTipi === 2 || x.uyeTipi === 3)
                    )
                  );
                default:
                  return organizeMenu(
                    res.data.filter(
                      (x: any) => x.panel === 1 && x.aktifPasif === 'A'
                    )
                  );
              }
            })()
            : organizeMenu(
              res.data.filter(
                (x: any) => x.panel === 1 && x.aktifPasif === 'A' && x.uyeTipi === 2
              )
            );
          const organizedMenuAlt = organizeMenu(
            res.data.filter((x: any) => x.panel === 2)
          );

          setMenuList(organizedMenu);

          setMenuListAltMenu(organizedMenuAlt);
        })
        .catch((err) => {
          console.log('eror:', err);
        });
    };

    fetchMenu();
  }, [kullaniciVarmi]);

  useEffect(() => {
    const fetchYear = async () => {
      YilListeAPI.getYilListe()
        .then((res) => {
          setYearListeDatas(res.data);
        })
        .catch((err) => {
          console.log("eror:", err);
        });
    };

    fetchYear();
  }, []);

  useEffect(() => {
    let fetchMahalle = async () => {
      MahalleListeAPI.getMahalleListe()
        .then((res) => {
          setMahalleListeDatas(res.data);
        })
        .catch((err) => {
          console.log("eror:", err);
        });
    };
    fetchMahalle();
  }, []);

  useEffect(() => {
    let fetchBolge = async () => {
      BolgeKoduAPI.getBolgeKoduiste()
        .then((res) => {
          setBolgeListeDatas(res.data);
        })
        .catch((err) => {
          console.log("eror:", err);
        });
    };
    fetchBolge();
  }, []);

  useEffect(() => {
    DuyurularAPI.getDuyurularListe()
      .then((res) => {
        setDuyurularListe(res.data);
      })
      .catch((err) => {
        console.log("Duyurular çekilemedi:", err);
      });
  }, []);

  return (
    <ThemeProviderComponent>
      <ConstantAPISContext.Provider
        value={{
          yilListe: yearListeDatas,
          mahalleListe: mahalleListeDatas,
          menuList: menuList,
          menuListAll: menuListAll,
          bolgeListe: bolgeListeDatas,
          menuListAltMenu: menuListAltMenu,
          kullaniciVarmi,
          setKullaniciVarmi,
          duyurularListe,
          setDuyurularListe
        }}
      >
        <BrowserRouter

        >
          <CssBaseline />
          <Layout>
            <LocalizationProvider dateAdapter={AdapterDayjs}  adapterLocale="tr">
              <AppRoute />
            </LocalizationProvider>

          </Layout>
        </BrowserRouter>
      </ConstantAPISContext.Provider>
    </ThemeProviderComponent>
  );
};

export default App;
